import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('my-approvals-sales', storeModule.createStoreModule('my-approvals-sales'))
